import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=7bd76130&"
import script from "./DashboardV2.vue?vue&type=script&lang=js&"
export * from "./DashboardV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports